import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { getHasThemePresetsInUniversalThemeEditorAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getActiveThemePresetId, getSelectedThemePresetId } from 'theme-previewer-lib/selectors/presetsSelectors';
const getTheme = basicSelector(state => state.theme);
export const getHasTheme = createSelector([getTheme], theme => theme ? theme.hasTheme : false);
export const getThemeObject = createSelector([getTheme], theme => theme ? theme.theme : null);
export const getThemeSettings = createSelector([getTheme], theme => theme ? theme.themeSettings : null);
export const getHasThemeSettings = createSelector([getTheme, getHasTheme], (theme, hasTheme) => hasTheme && !!theme && theme.hasThemeSettings);
export const getOverriddenThemeSettings = createSelector([getTheme], theme => theme ? theme.overriddenThemeSettings : null);
export const getThemePath = createSelector([getThemeObject], theme => theme ? theme.path : null);
export const getParentThemePath = createSelector([getThemeObject], theme => theme ? theme.parentThemePath : null);
export const getThemeFormSpec = createSelector([getThemeObject], theme => {
  if (!theme) {
    return {
      fields: [],
      messages: {}
    };
  }
  return {
    fields: theme.fields || [],
    messages: theme.messages || {}
  };
});
export const getThemeName = createSelector([getThemeObject], theme => theme ? theme.name : null);
export const getThemeGlobalSettings = createSelector([getThemeSettings], themeSettings => {
  if (!themeSettings) {
    return {};
  }
  return themeSettings.values || {};
});
export const getThemesCustomFontsList = createSelector([getTheme], theme => theme ? theme.customFonts : []);
export const selectThemeVariantName = createSelector([getThemeSettings], themeSettings => themeSettings ? themeSettings.variantName : null);
export const getThemePresetIdForPreview = createSelector([getHasThemePresetsInUniversalThemeEditorAccess, getActiveThemePresetId, getSelectedThemePresetId], (hasThemePresetsInUniversalThemeEditorAccess, activeThemePresetId, selectedThemePresetId) => {
  if (hasThemePresetsInUniversalThemeEditorAccess) {
    // If there's an active preset but we want to preview the theme defaults, 0 will force
    // the CSS assets fetch to use theme defaults with no preset styles. Otherwise, setting
    // theme_preset_id to undefined will use the active theme preset styles.
    return activeThemePresetId && !selectedThemePresetId ? 0 : selectedThemePresetId;
  }
  return undefined;
});